import { render, staticRenderFns } from "./Preguntas_lista.vue?vue&type=template&id=38e80f35&scoped=true"
import script from "./Preguntas_lista.vue?vue&type=script&lang=js"
export * from "./Preguntas_lista.vue?vue&type=script&lang=js"
import style0 from "./Preguntas_lista.vue?vue&type=style&index=0&id=38e80f35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e80f35",
  null
  
)

export default component.exports